import { CLEARANCE_TAG, SEARCH_PROMOTION_ACTIVE_TAG } from '~/constants';

const getFilteredTags = (tags: string[]): string[] => {
  return tags.filter((tag) => tag !== SEARCH_PROMOTION_ACTIVE_TAG).slice(0, 2);
};

const getClearanceTag = (
  price: number | undefined | null,
  compareToPrice: number | undefined | null,
  filteredTags: string[],
): string[] => {
  const isOnSale =
    typeof price === 'number' && typeof compareToPrice === 'number' && compareToPrice > price;

  if (!isOnSale || filteredTags.length > 0 || !CLEARANCE_TAG) {
    return [];
  }

  return [CLEARANCE_TAG];
};

export const getProductTags = (
  price: number | undefined | null,
  compareToPrice: number | undefined | null,
  tags: string[],
  showClearanceTag = true,
): string[] => {
  const filteredTags = getFilteredTags(tags);

  if (showClearanceTag) {
    return [...filteredTags, ...getClearanceTag(price, compareToPrice, tags)];
  }

  return filteredTags;
};
